import { CaviarWeights, Weights } from './constants';
export var getResolvedWeight = function getResolvedWeight(fontFamily, textWeight) {
  if (fontFamily === 'Caviar' || fontFamily === 'Caviar-Market') {
    return CaviarWeights[textWeight];
  }

  return Weights[textWeight];
};
export var getResolvedWeightWithTheme = function getResolvedWeightWithTheme(theme, textWeight) {
  return getResolvedWeight(theme.Typography.FontFamily, textWeight);
};